import { useEffect, useState, type ReactNode } from 'react'

/**
 * Standalone-оболочка: тема следует за системной (prefers-color-scheme).
 * Классы app-shell--dark/light переключают токены дизайн-системы.
 */
export const AppShell = ({ children }: { children: ReactNode }) => {
  const [theme, setTheme] = useState<'light' | 'dark'>(() =>
    typeof window !== 'undefined' && window.matchMedia('(prefers-color-scheme: dark)').matches
      ? 'dark'
      : 'light',
  )

  useEffect(() => {
    const mq = window.matchMedia('(prefers-color-scheme: dark)')
    const onChange = (event: MediaQueryListEvent) => setTheme(event.matches ? 'dark' : 'light')
    mq.addEventListener('change', onChange)
    return () => mq.removeEventListener('change', onChange)
  }, [])

  // Theme classes go on <html> so derived tokens like `--bg: var(--color-bg)`
  // (declared on :root) re-resolve against the dark palette — otherwise the
  // page background stays light while surfaces go dark.
  useEffect(() => {
    const root = document.documentElement
    root.classList.add('app-shell--telegram')
    root.classList.toggle('app-shell--dark', theme === 'dark')
    root.classList.toggle('app-shell--light', theme === 'light')
    return () => {
      root.classList.remove('app-shell--telegram', 'app-shell--dark', 'app-shell--light')
    }
  }, [theme])

  return <div className={`app-shell app-shell--telegram app-shell--${theme}`}>{children}</div>
}
